import React from 'react';
import { X } from 'lucide-react';

// The strip that appears above a list once rows are ticked, and the tick box
// that goes in a row or a header. One copy so that picking rows looks and
// behaves the same on every screen, rather than each list inventing its own.

export function TickBox({ checked, onChange, label, testId }) {
  return (
    <input
      type="checkbox"
      checked={!!checked}
      onChange={onChange}
      aria-label={label}
      className="w-4 h-4 accent-[#8BC53F] cursor-pointer"
      data-testid={testId}
    />
  );
}

export default function BulkBar({ count, onClear, children, testId = 'bulk-action-bar',
                                  countTestId = 'bulk-selected-count', note }) {
  if (!count) return null;
  return (
    <div
      className="px-4 py-2.5 bg-[#8BC53F]/10 border-b border-[#8BC53F]/30 flex flex-wrap items-center gap-2"
      data-testid={testId}
    >
      <span className="text-sm font-bold text-slate-700 mr-1" data-testid={countTestId}>
        {count} selected
      </span>
      {note && <span className="text-xs text-slate-500 mr-1">{note}</span>}
      {children}
      <button
        onClick={onClear}
        className="ml-auto text-slate-500 hover:text-slate-800 flex items-center gap-1 text-sm"
        data-testid="bulk-clear-btn"
      >
        <X className="w-4 h-4" />Clear
      </button>
    </div>
  );
}
